/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status of the pre-booking validation
 * @export
 */
export const PreBookResponseStatus = {
    Success: 'SUCCESS',
    Warning: 'WARNING',
    Error: 'ERROR'
} as const;
export type PreBookResponseStatus = typeof PreBookResponseStatus[keyof typeof PreBookResponseStatus];


export function instanceOfPreBookResponseStatus(value: any): boolean {
    for (const key in PreBookResponseStatus) {
        if (Object.prototype.hasOwnProperty.call(PreBookResponseStatus, key)) {
            if (PreBookResponseStatus[key as keyof typeof PreBookResponseStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PreBookResponseStatusFromJSON(json: any): PreBookResponseStatus {
    return PreBookResponseStatusFromJSONTyped(json, false);
}

export function PreBookResponseStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreBookResponseStatus {
    return json as PreBookResponseStatus;
}

export function PreBookResponseStatusToJSON(value?: PreBookResponseStatus | null): any {
    return value as any;
}

export function PreBookResponseStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): PreBookResponseStatus {
    return value as PreBookResponseStatus;
}

